import { render, staticRenderFns } from "./QualityBlock.vue?vue&type=template&id=b7f0c2ba&scoped=true&"
import script from "./QualityBlock.vue?vue&type=script&lang=js&"
export * from "./QualityBlock.vue?vue&type=script&lang=js&"
import style0 from "./QualityBlock.vue?vue&type=style&index=0&id=b7f0c2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f0c2ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
